import { useState, useEffect } from 'react';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3003/api';

interface Unit {
  id: number;
  name: string;
  displayName: string;
  symbol: string;
}

interface UnitOption {
  value: string;
  label: string;
}

export const useUnits = () => {
  const [units, setUnits] = useState<Unit[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchUnits = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${API_BASE_URL}/units`);
      const result = await response.json();

      if (result.success) {
        setUnits(result.data);
      } else {
        setError(result.error || 'Error al cargar unidades');
      }
    } catch (err) {
      console.error('Error fetching units:', err);
      setError('Error de conexión al cargar unidades');
    } finally {
      setLoading(false);
    }
  };

  const getUnitOptions = (): UnitOption[] => {
    return units.map(unit => ({
      value: unit.name,
      label: unit.displayName || unit.name
    }));
  };

  useEffect(() => {
    fetchUnits();
  }, []);

  return {
    units,
    unitOptions: getUnitOptions(),
    loading,
    error,
    refetch: fetchUnits
  };
};
